import { apolloClient } from '~/apollo-client';
import { FetchFunnelPacketResponse } from '~/services/fetch-funnel-packet';
import {
  Flex_FetchLmiProofDocLabelOptionsQuery,
  Flex_FetchLmiProofDocLabelOptionsQueryVariables,
} from '~/typings/graphql';
import { FETCH_LMI_PROOF_DOC_LABEL_OPTIONS } from './fetch-lmi-proof-doc-label-options.queries';
import {
  Category,
  FetchLmiProofDocLabelOptionsParams,
  FetchLmiProofDocLabelOptionsResponse,
  getFetchLmiProofDocLabelOptionsParams,
  isValidFetchLmiProofDocLabelOptionsParams,
  LMI_PROOF_UPLOAD_CATEGORY,
  normalizeLmiProofDocLabelData,
  NormalizedLmiProofDocLabelOptions,
} from './utils';

export type {
  Category,
  FetchLmiProofDocLabelOptionsParams,
  FetchLmiProofDocLabelOptionsResponse,
  NormalizedLmiProofDocLabelOptions,
};
export {
  getFetchLmiProofDocLabelOptionsParams,
  isValidFetchLmiProofDocLabelOptionsParams,
  LMI_PROOF_UPLOAD_CATEGORY,
  normalizeLmiProofDocLabelData,
};

export const fetchLmiProofDocLabelOptions = async (
  params: FetchLmiProofDocLabelOptionsParams,
): Promise<FetchLmiProofDocLabelOptionsResponse> => {
  if (!isValidFetchLmiProofDocLabelOptionsParams(params)) {
    return { data: null };
  }

  const { data } = await apolloClient.query<
    Flex_FetchLmiProofDocLabelOptionsQuery,
    Flex_FetchLmiProofDocLabelOptionsQueryVariables
  >({
    query: FETCH_LMI_PROOF_DOC_LABEL_OPTIONS,
    variables: {
      utilityId: params.utilityId,
      category: params.category,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    data: data.lmiProofDocLabelOptions?.data || null,
  };
};

/** Fetches and normalizes proof-doc label options for upload / LMI review flows. */
export const fetchLmiProofDocLabelOptionsForUpload = async (
  funnelPacket: FetchFunnelPacketResponse | undefined,
): Promise<NormalizedLmiProofDocLabelOptions> => {
  const params = getFetchLmiProofDocLabelOptionsParams(funnelPacket);
  if (!params) {
    return null;
  }

  try {
    const { data } = await fetchLmiProofDocLabelOptions(params);
    return normalizeLmiProofDocLabelData(data);
  } catch {
    return null;
  }
};
